import { useMutation } from '@apollo/client';
import { BasicPricingTaxi, UpdateBasicPricingTaxiInput } from '../../shared/types';
import { UpdateBasicTaxiPricingResponse, UpdateBasicTaxiPricingRequest, CITRIN_UPDATE_BASIC_TAXI_PRICING } from '..';

type UpdateMutationFunction = (request: UpdateBasicPricingTaxiInput) => Promise<BasicPricingTaxi>;
export const useUpdateBasicPricingTaxiMutation = (): { mutation: UpdateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<UpdateBasicTaxiPricingResponse, UpdateBasicTaxiPricingRequest>(
        CITRIN_UPDATE_BASIC_TAXI_PRICING
    );
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_updateBasicTaxiPricing;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
